import { Pipe, PipeTransform } from '@angular/core';
import { CreditRequestStatus } from '@services';

@Pipe({
    name: 'creditRequestStatus',
    standalone: true,
})
export class CreditRequestStatusPipe implements PipeTransform {
    transform(value: CreditRequestStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case CreditRequestStatus.Draft: return 'Draft';
            case CreditRequestStatus.PendingAP: return 'Pending AP';
            case CreditRequestStatus.Cancelled: return 'Cancelled';
            case CreditRequestStatus.Completed: return 'Completed';
            default:
                return value;
        }
    }
}